export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/t_shirts.687b471.svg";